export default "__VITE_ASSET__C94o6QdM__"